module.exports = __webpack_public_path__ + "img/360-montering-1.4e4142b5.jpg";